import { Component, type ReactNode } from 'react';
import { ErrorDeCarga } from './Estado.js';

/**
 * El piso de la app: si una pantalla no se puede dibujar, se dice (P-65).
 *
 * Sin esto, un error al cargar una pantalla —el caso típico es un chunk que ya
 * no está en el servidor después de un deploy— desmonta todo el árbol de React
 * y deja la pantalla **en blanco y muda**. `cargarConRecuperacion` ya recarga
 * una vez contra la red; esto es para cuando ni así alcanza: el error del
 * sistema (S-02) con su "Reintentar", que recarga la página.
 */
export class LimiteDeError extends Component<
  { children: ReactNode; recargar?: () => void },
  { fallo: boolean }
> {
  override state = { fallo: false };

  static getDerivedStateFromError(): { fallo: boolean } {
    return { fallo: true };
  }

  override render() {
    if (!this.state.fallo) return this.props.children;
    const recargar = this.props.recargar ?? (() => globalThis.location.reload());
    return (
      <main className="mx-auto flex min-h-dvh w-full max-w-lg flex-col justify-center p-6">
        <ErrorDeCarga onReintentar={recargar} />
      </main>
    );
  }
}
